import Router from "./main";

export default Router;
